<template>

  <div>
    <b-dropdown right offset="-20 15" :animation="animation" variant="link" no-caret class="create-section-menu">
      <template slot="button-content">
        <span class="icon-menu3x3"></span>
      </template>
      <b-dropdown-item>Test Dropdown Item</b-dropdown-item>
      <!--<b-dropdown-item disabled>Edit</b-dropdown-item>-->
      <!-- <b-dropdown-item @click="printScreen()">Print</b-dropdown-item> -->
      <!-- <b-dropdown-item v-if="canExportInstitution" @click="exportInstitution">Export To CSV</b-dropdown-item> -->
    </b-dropdown>
    <!--<span class="icon-channel"></span>-->
    <!--<button class="btn icon-share2"></button>-->
    <!-- <span class="fas fa-exclamation-circle"></span> -->
    <!--<button class="btn" disabled>plan institution  <span class="circle"></span></button> -->
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
// import { PACKAGE } from '../../../package_constants'
// import { PackageUtil } from '../../../package_utils'

export default {
  name: 'institutionHeader',
  props: ['uuid'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadPermission()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadPermission'
    ]),
    navigateToProgramGuideView () {
      this.loadLogDashboardActivity({action: 'clickProgramGuideView', page: 'Program Guide View', link: 'Program Guide', entityUuid: this.uuid})
      return this.$router.push({ name: 'programGuide', params: { uuid: this.uuid } })
    },
    printScreen () {
      window.print()
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    writeFile (data) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = this.csvFileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    }
  },

  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'permission': state => state.user.permission,
      'packages': state => state.institution.packages
    })
  },

  watch: {
  }
}
</script>
<style>
.institution-left-panel {
	.institution-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionHeader.vue